import React from "react";
import styles from "./list.module.scss";
import { useIsMobile } from "../../hooks/mobile.js";

import ListItem from "../list-item/list-item";
import Download from "../download/download";

const TOPIC_ICON_SIZE = 24;

export default function List(props) {
    const isMobile = useIsMobile();
    const {
        themes,
        opportunities,
        filteredOpportunities,
        topics,
        handleReset,
        selectedOpportunity,
        handleHideCompleted,
        hideCompleted,
        completed,
        handleScrollToTop,
    } = props;

    return (
        <div className={styles.list}>
            <h3 className={styles.listHeading}>
                <span className={styles.listHeadingOpportunities}>
                    {filteredOpportunities.length === 1
                        ? `${filteredOpportunities.length} opportunity`
                        : `All ${filteredOpportunities.length} opportunities`}
                </span>
                {completed > 0 && (
                    <span className={styles.completed} onClick={handleHideCompleted}>
                        {hideCompleted
                            ? `Show ${completed} completed ${completed === 1 ? "opportunity" : "opportunities"}`
                            : `Hide ${completed} completed ${completed === 1 ? "opportunity" : "opportunities"}`}
                    </span>
                )}
                {!isMobile &&
                    filteredOpportunities.length < opportunities.length &&
                    (!hideCompleted || completed === 0) && (
                        <button className={styles.listHeadingReset} onClick={() => handleReset()}>
                            Reset to all opportunities
                        </button>
                    )}
            </h3>
            <p className={styles.statusNote}>
                If the Authority is supporting or collaborating on any project-level opportunities, it will be marked as
                "research in progress". If you wish to discuss if further work is required, please contact the science
                team. If a project-level opportunity has been concluded or removed as a priority, it will be marked as
                “completed".
            </p>
            <div className={styles.listSummary}>
                <small>Sorted by topic, alphabetically</small>
                {!isMobile && <Download />}
            </div>
            {topics && opportunities && (
                <div className={styles.listContainer}>
                    {topics.map(t => {
                        return (
                            <React.Fragment key={t.slug}>
                                {filteredOpportunities.filter(o => o.topic.topic === t.topic).length > 0 && (
                                    <div className={styles.listGroup} key={t.slug}>
                                        <h4 className={styles.listGroupHeading}>
                                            <span className={styles.listGroupHeadingIcon}>
                                                <img
                                                    src={"data:image/svg+xml," + encodeURIComponent(t.icon)}
                                                    alt={t.topic}
                                                    className={styles.topicIcon}
                                                    style={{ height: TOPIC_ICON_SIZE, width: "auto" }}
                                                    aria-hidden="true"
                                                    height={TOPIC_ICON_SIZE}
                                                    width="auto"
                                                />
                                            </span>
                                            <span className={styles.topic}>{t.topic}</span>
                                            <button className={styles.backToTop} onClick={handleScrollToTop}>
                                                Back to top
                                            </button>
                                        </h4>
                                        {filteredOpportunities
                                            .filter(o => o.topic.topic === t.topic)
                                            .map(d => (
                                                <ListItem
                                                    opportunity={d}
                                                    key={d.short}
                                                    themes={themes}
                                                    selectedOpportunity={selectedOpportunity}
                                                />
                                            ))}
                                    </div>
                                )}
                            </React.Fragment>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
